import type { Provider } from '@angular/core';

import type { IThirdPartyService } from './third-party.models';
import { ThirdPartyService } from './third-party.service';

export function provideThirdPartyBrowserService(): Provider {
	return {
		provide: ThirdPartyService,
		useValue: <IThirdPartyService>{
			inject: () => null,
			appendAssetsPreconnect: () => null,
		},
	};
}
